<form [formGroup]="forgotPasswordForm" (yatSubmit)="submitForm($event)">
  <div class="form-row">
    <div class="col-12">
      <yat-form-group labelFor="email" [label]="'accountUi.forgotPasswordForm.emailAddress.label' | transloco">
        <input
          type="email"
          id="email"
          formControlName="email"
          [placeholder]="'accountUi.forgotPasswordForm.emailAddress.label' | transloco"
          maxlength="254"
          yatAutoFocus
          yatInput />
        <div class="invalid-feedback order-2" [ngSwitch]="forgotPasswordForm.controls.email.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'accountUi.forgotPasswordForm.emailAddress.validators.required' | transloco }}</span>
          <span *ngSwitchCase="'email'">{{ 'accountUi.forgotPasswordForm.emailAddress.validators.email' | transloco }}</span>
        </div>
      </yat-form-group>
    </div>
  </div>
  <div class="form-row">
    <div class="col-lg-12 send-recovery-email">
      <button
        yat-button
        type="submit"
        class="btn primary w-100"
        yatAutoSpinner
        [matomoClickCategory]="MATOMO_EVENT_CATEGORY_ACCOUNT"
        matomoClickAction="Select_SendRecoveryEmail">
        <span>{{ 'accountUi.forgotPasswordForm.sendRecoveryEmail' | transloco }}</span>
      </button>
    </div>
  </div>
</form>
